import { cloneDeep, isEmpty } from "lodash";
import { memo, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../../../app/common-components/Button";
import { configurationApi } from "../../../../../app/services/configurationApi";
import { effciencyApi } from "../../../../../app/services/efficiencyApi";
import { useCommonAlert } from "../../../../../app/utilities/helpers";
import "../styles.scss";
import AccessTable from "./AccessTable";


const BitBucketRoles = () => {
  const [RoleState, setState] = useState({
    tableHeader: [],
    tableBody: [],
  });
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const { state } = useLocation();
  const row = state?.row;
  const navigate = useNavigate();
  const [getGroups] = effciencyApi.useLazyGetGroupsQuery();
  const [getAccessDetailsById] =
    configurationApi.useLazyGetAccessDetailsByIdQuery();
  const [saveConfig] = configurationApi.useSaveConfigMutation();

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.checked;
    const access = e.target.value;
    const clonedState = cloneDeep(RoleState);

    if (access === "Admin") {
      const adminArray = clonedState.tableBody[0].map((data) => {
        if (data.value === "Admin") {
          return {
            ...data,
            [name]: value,
          };
        }
        return {
          ...data,
          [name]: value,
          [`${name}_disable`]: value,
        };
      });

      setState((state) => ({
        ...state,
        tableBody: [adminArray],
      }));
    } else if (access === "Write") {
      const adminArray = clonedState.tableBody[0].map((data) => {
        if (data.value === access) {
          return {
            ...data,
            [name]: value,
          };
        } else if (data.value === "Read") {
          return {
            ...data,
            [name]: value,
            [`${name}_disable`]: value,
          };
        }
        return data;
      });
      setState((state) => ({
        ...state,
        tableBody: [adminArray],
      }));
    } else {
      const adminArray = clonedState.tableBody[0].map((data) => {
        if (data.value === access) {
          return {
            ...data,
            [name]: value,
          };
        }
        return data;
      });
      setState((state) => ({
        ...state,
        tableBody: [adminArray],
      }));
    }
  };
  const mapObject = (data, parentObject, tool) => {
    let grpObject = {};
    data.forEach((grp) => {
      let fieldPresent = false;
      if (!isEmpty(parentObject)) {
        Object.keys(parentObject).forEach((key) => {
          if (key === grp.groups) {
            parentObject[key].forEach((access) => {
              if (tool === access.toLowerCase()) {
                fieldPresent = true;
                grpObject[key] = true;
              }
            });
          }
        });
      }
      if (!fieldPresent) {
        grpObject[grp.groups] = false;
      }
    });
    return grpObject;
  };
  const getGroup = async () => {
    const { data } = await getGroups();
    const accessData = await getAccessDetailsById(row.id);
    const tableHeader = [
      [
        {
          key: 1,
          text: "Permissions",
          rowSpan: "2",
          width: "25%",
        },
        {
          key: 2,
          text: "Role",
          colSpan: data.length,
          className: "text-center",
        },
      ],
    ];
    const subHeaders = data.map((grp, idx) => ({
      key: idx,
      text: grp.groups,
      className: "text-center toolbit_confic",
    }));
    tableHeader.push(subHeaders);
    const parentObject = accessData?.isSuccess
      ? JSON.parse(accessData?.data.permission)
      : {};
    const bitlist=["Admin","Write","Read"];

    const tableBody = bitlist.map((tool) => {
      const tmpdata = mapObject(data, parentObject, tool.toLowerCase());
      return {
        value: tool,
        ...tmpdata,
      };
    });

    setState((state) => ({
      ...state,
      tableHeader,
      tableBody: [tableBody],
    }));
  };

  const getPermission = () => {
    const devopsToolGroups = {};
    RoleState.tableBody.forEach((data) => {
      data.forEach((item) =>
        Object.keys(item).forEach((key) => {
          if (item[key] === true && !key.includes("_disable")) {
            devopsToolGroups[key] = devopsToolGroups[key]
              ? devopsToolGroups[key]
              : [];
            devopsToolGroups[key].push(item.value.toUpperCase());
          }
        })
      );
    });
    return devopsToolGroups;
  };
  const cancelConfig = () => {
    navigate("/configuration/administration/tools");
  };
  const saveConfiguration = () => {
    localStorage.removeItem("toolsCurrentPage");
    localStorage.removeItem("isConfigClicked");
    const permissionData = getPermission();

    const { id, toolName, type, userName, password, url, apiToken, sslValue } =
      row;
    const payload = {
      devopsToolGroups: JSON.stringify(permissionData, null, 4),
      toolId: row.id,
      tools: {
        id,
        toolName,
        type,
        userName,
        password,
        url,
        apiToken,
        sslValue,
      },
    };
    saveConfig({ payload,userName }).then((data) => {
      if (data.error.originalStatus === 201) {
        callCommonAlert("success",data.error.data);
        hideCommonAlert();
        setTimeout(() => navigate("/configuration/administration/tools"), 2000);
      } else {
        callCommonAlert("error","Bitbucket role configuration failed to save");
        hideCommonAlert();
      }
    });
  };

  useEffect(() => {
    if(state === null){
      navigate("/configuration/administration/tools");
      return;
    }
    getGroup();
  }, []);

  return (
    <>
      <div className="grid-table">
        <AccessTable
          tableHeaders={RoleState.tableHeader}
          body={RoleState.tableBody}
          onChange={(e) => handleOnChange(e)}
        />
      </div>
      <div className="btnwrap config_btn">
        <Button
          text="Cancel"
          className={"cancelBtnStyle btn btn-primary-btn-btn"}
          onClick={(e) => {
            e.preventDefault();
            cancelConfig();
          }}
        />
        <Button
          text="Save"
          className={"btnStyle btn btn-primary-btn-btn"}
          onClick={(e) => {
            e.preventDefault();
            saveConfiguration();
          }}
        />
      </div>
    </>
  );
};

export default memo(BitBucketRoles);
